module.exports = __webpack_public_path__ + "static/media/folder.bbde23de.svg";